import { useTranslation } from "react-i18next";
 import { Card, CardBody, Col, Container, Row, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { UserListTableData } from "../../../data/users/UsersList";
import { Badges, H3, H5, Image, SVG } from "../../../AbstractElements";
import { dynamicImage } from "../../../service";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
 import InviteSignupModal from "../../common/InviteSignupModal";
import { MoreVertical } from "react-feather";
import { showWarningAlert } from "../../../utils/showWarningAlert";
import { UserListTableDataColumnType } from "../../../types/users/UserTypes";
import CommonModal from "../../modal/common/CommonModal";
import UserResetPassword from "../../modal/common/user-reset-password/UserResetPassword";
import FilterSearchSection from "../../common/filter-section/FilterSearchSection";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";

function DevelopersPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const doubledData = [...UserListTableData, ...UserListTableData];
  const [visibleCount, setVisibleCount] = useState(8);
  const [showInviteModal, setShowInviteModal] = useState(false);

  const handleScroll = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 100
    ) {
      setVisibleCount((prev) => Math.min(prev + 2, doubledData.length));
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleAddUser = () => {
    navigate("/users/developers/new");
  };

  const handleInvite = () => {
    setShowInviteModal(true);
  };

  const handleCloseInviteModal = () => {
    setShowInviteModal(false);
  };

  const DevelopersListTableAction: React.FC<{ row: UserListTableDataColumnType }> = ({ row }) => {
    const [selectedUser, setSelectedUser] = useState<UserListTableDataColumnType | null>(null);
    const [staticModal, setStaticModal] = useState(false);

    const staticModalToggle = () => {
      setStaticModal(!staticModal);
      setSelectedUser(row);
    };

    const handleBlock = () => {
      showWarningAlert({
        title: t("Are you sure?"),
        text: `Do you want to block ${row.name}?`,
        confirmButtonText: t("Block"),
        onConfirm: () => {
         },
      });
    };

    const handleUnblock = () => {
      showWarningAlert({
        title: t("Are you sure?"),
        text: `Do you want to unblock ${row.name}?`,
        confirmButtonText: t("Unblock"),
        onConfirm: () => {
         },
      });
    };

    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className="cursor-pointer">
          <MoreVertical size={18} />
        </DropdownToggle>
        <DropdownMenu>
          <Link to={`${process.env.PUBLIC_URL}/users/developers/view/${row.id}`}>
            <DropdownItem>{t("View")}</DropdownItem>
          </Link>
          <Link to={`${process.env.PUBLIC_URL}/users/developers/edit/${row.id}`}>
            <DropdownItem>{t("Edit")}</DropdownItem>
          </Link>
          {row.status === "Active" ? (
            <DropdownItem onClick={handleBlock}>{t("Block")}</DropdownItem>
          ) : (
            <DropdownItem onClick={handleUnblock}>{t("Unblock")}</DropdownItem>
          )}
          <DropdownItem onClick={staticModalToggle}>
            {t("ResetPassword")}
          </DropdownItem>
          <Link to={`${process.env.PUBLIC_URL}/users/developers/activity-logs/${row.id}`}>
            <DropdownItem>{t("ActivityLog")}</DropdownItem>
          </Link>
          <Link to={`${process.env.PUBLIC_URL}/users/developers/user-access-rights/${row.id}`}>
            <DropdownItem>{t("AccessRights")}</DropdownItem>
          </Link>
        </DropdownMenu>
        <CommonModal
          backdrop="static"
          modalBodyClassName="social-profile text-start"
          isOpen={staticModal}
          toggle={staticModalToggle}
        >
          <H3 className="modal-header justify-content-center border-0">
            <span className="font-primary email_add_0">{selectedUser?.organizationname}</span>
          </H3>
          <div className="modal-toggle-wrapper">
            <UserResetPassword staticModalToggle={staticModalToggle} data={selectedUser} />
          </div>
        </CommonModal>
      </UncontrolledDropdown>
    );
  };

  return (
    <>
      <Breadcrumbs mainTitle={t("Developers")} parent={t("Users")} />
      <Container fluid>
        <FilterSearchSection
          hideOrganization={true}
          showUserActions={true}
          onAddUser={handleAddUser}
          onInvite={handleInvite}
        />
        <Row>
          {doubledData.slice(0, visibleCount).map((item) => (
            <Col
              xl="4"
              sm="6"
              xxl="3"
              className="col-ed-4 box-col-4"
              key={item.id + "-" + item.name + "-" + Math.random()}
            >
              <Card className="social-profile">
                <CardBody>
                  <div className="social-img-wrap">
                    <div className="social-img">
                      <Image src={dynamicImage(item.image)} alt="user" />
                    </div>
                    <div className="edit-icon">
                      <SVG iconId="profile-check" />
                    </div>
                  </div>
                  <div style={{ position: "absolute", top: 10, right: 10 }}>
                    <DevelopersListTableAction row={item} />
                  </div>
                  <div className="social-details">
                    <H5 className="mb-1">
                      <Link to="">{item.name}</Link>
                    </H5>
                  </div>
                  <div className="social-details">
                    <H3 className="mb-1">
                      <Link to="">{item.organizationname}</Link>
                    </H3>
                  </div>
                  <Badges
                    color="transparent"
                    className={`badge-light-${
                      item.status === "Inactive" ? "secondary" : "success"
                    }`}
                  >
                    {item.status}
                  </Badges>
                  <hr />
                  <div className="social-details">
                    <H5 className="mb-1 d-flex align-items-center gap-2">
                      <i className="fa fa-phone" />
                      <Link to="">{item.phonenumber}</Link>
                    </H5>
                    <H5 className="mb-1 d-flex align-items-center gap-2">
                      <i className="fa fa-envelope" />
                      <span className="f-light"> {item.email}</span>
                    </H5>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <InviteSignupModal 
        isOpen={showInviteModal}
        onClose={handleCloseInviteModal}
      />
    </>
  );
}

export default DevelopersPage;